import { useContext } from 'react'
import { LoggedInUserContext } from '~/context/LoggedInUser'

function useLoggedInUser() {
  const context = useContext(LoggedInUserContext)

  if (!context) {
    throw new Error('useLoggedInUser() must be used within a LoggedInUserProvider')
  }

  return context
}

export default useLoggedInUser
